module.exports = __webpack_public_path__ + "img/ico-apple.b267322.svg";